<div class="px-4 py-8">
  <h3 class="mb-5 text-center text-xl font-semibold">Add Test Room</h3>
  <form [formGroup]="form">

  <!-- Room Name -->
  <mat-form-field appearance="outline" class="w-full mb-4">
    <mat-label>Room Name</mat-label>
    <input matInput formControlName="name" placeholder="Room name" />
  </mat-form-field>

  <!-- Status -->
  <mat-form-field appearance="outline"  >
    <mat-label>Status</mat-label>
    <mat-select formControlName="status" required>
      <mat-option *ngFor="let s of allTestRoomStatusOptions" [value]="s.value">
        {{ s.viewValue }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('status')?.hasError('required')">
      Status is required
    </mat-error>
  </mat-form-field>

  <!-- Peripherals -->
  <mat-checkbox formControlName="hasCamera">Has Camera</mat-checkbox>
  <mat-checkbox formControlName="hasTablet" class="ml-4">Has Tablet</mat-checkbox>
              <app-department-select
        [disabled]="isDepartmentDisabled"
        [required]="true"
        [selectedValue]="form.value.departmentId"
        (departmentSelected)="onDepartmentChange($event)"
      >
      </app-department-select>
</form>
  <!-- Buttons -->
  <div class="flex justify-between pt-4 space-x-2">
    <button type="button" mat-stroked-button (click)="onClose()">Cancel</button>
    <button type="button" mat-flat-button color="primary" (click)="save()">
      {{ isLoading ? "Saving..." : "Save" }}
    </button>
  </div>
</div>
